import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import AppPanel from '../fw/AppPanel.react';

import types from '../../common/model-api/types';

import PagingGrid, {defaultPageSize, processPagingParams} from '../fw/PagingGrid.react';
import AddButton from '../fw/AddButton.react';
import urlMapping from '../app/URLMapping';
import { User } from '../../common/types/types';
import {parseOrganisationLabels} from '../../common/util/OrganisationLabels.ts';

const messages = defineMessages({
    title: {id: 'organisationList.title', 'defaultMessage': 'Organisations'}
});

interface OrganisationListProps {
    intl: IntlShape;
    relay?: object;
    user: User;
}

class OrganisationList extends React.Component<OrganisationListProps> {

    typeName = 'organisations';

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object,
        user: PropTypes.object.isRequired
    };

    renderOrganisationLabels(org) {
        if (!org) {
            return null;
        }

        const labels = parseOrganisationLabels(org.labels);
        if (labels.length === 0) {
            return null;
        }

        return (
            <small className="organisationLabels" style={{marginLeft: '12px'}}>
                {labels.map((label) => <span className="label label-default" key={label} style={{marginRight: '4px'}}>{label}</span>)}
            </small>
        );
    }

    render() {
        let { user } = this.props;

        let type = types[this.typeName];
        let list = user.organisations;

        return (
            <AppPanel breadcrumbParams={[
                {type: types['organisations']},
            ]} title={this.props.intl.formatMessage(messages.title)}>
                    <PagingGrid
                        columns={{
                            'logo': {
                                className: 'width50px',
                                header: <span></span>,
                                render: (column, item, url, columnMapping) => {
                                    return item.logo ? <img style={{maxWidth: '48px', maxHeight: '48px', marginTop: '-12px', 'marginBottom': '-12px'}} src={item.logo} alt={item.name} /> : null;
                                }
                            },
                            'name': {
                                render: (column, item, url, columnMapping) => {
                                    return (
                                        <span>
                                            {item.name}
                                            {this.renderOrganisationLabels(item)}
                                        </span>
                                    );
                                }
                            }, 
                            'description': {}
                        }}
                        edges={list}
                        metadata={type}
                        pageInfo={list.pageInfo}
                        relay={this.props.relay}
                        urlMapping={urlMapping} />

                    <AddButton metadata={type} urlMapping={urlMapping} user={this.props.user} />
            </AppPanel>
        );
    }
}

export default Relay.createContainer(injectIntl(OrganisationList), {
    initialVariables: {
        first: defaultPageSize,
        after: null,
        before: null,
        last: null,
    },
    prepareVariables (variables) {
        processPagingParams(variables);

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                globalPermissions,
                id,
                organisations(first: $first, after: $after, before: $before, last: $last) {
                    edges {
                        node {
                            id,
                            realId,
                            name,
                            description,
                            logo,
                            labels,
                        }
                    },
                    pageInfo {
                        hasNextPage,
                        hasPreviousPage,
                        startCursor,
                        endCursor
                    }
                }
            }
        `,
    },
});
